/*
 * Copyright (c) 2017 Honeywell International, Inc. All rights reserved.
 *
 * This file contains trade secrets of Honeywell International, Inc.  No part
 *  may be reproduced or transmitted in any form by any means or for any
 *  purpose without the express written permission of Honeywell.
 *
 */

import {Equipment} from './equipment.model';
import {Point} from './point.model';

export class Asset {
  id: string;
  label: string;
  confirmed: boolean;
  status: string;
  equipment: Equipment;
  points: Array<Point>;
  pointsWithRolesCount: number;
  location: string;
}
